import api from '../utils/api';

// Fetch all courses
export const getAllCourses = async (headers) => {

  try {
    const response = await api.get('/api/courses',  headers );
    console.log('Fetched course response:', response.data); 
    return response.data;
  } catch (error) {
    console.error('Error fetching courses:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific course by ID
export const getCourseById = async (id, headers) => {
  try {
    const response = await api.get(`/api/courses/${id}`,  headers );
 
    return response.data;
  } catch (error) {
    console.error(`Error fetching course with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new course
export const createCourse = async (courseData, headers) => {
  try {
    const response = await api.post('/api/courses', courseData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error creating course:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing course
export const updateCourse = async (id, courseData, headers) => {
  console.log("courses", courseData)
  try {
    const response = await api.put(`/api/courses/${id}`, courseData,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error updating course with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a course
export const deleteCourse = async (id, headers) => {
  try {
    const response = await api.delete(`/api/courses/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error deleting course with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch courses for a specific teacher
export const getTeacherCourses = async (teacherId, headers) => {
  try {
    const response = await api.get(`/api/courses/teacher/${teacherId}/courses`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error fetching courses for teacher with ID ${teacherId}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch courses for a specific student
export const getStudentCourses = async (studentId, headers) => {
  try {
    const response = await api.get(`/api/courses/student/${studentId}/courses`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error fetching courses for student with ID ${studentId}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Enroll a student in a course
export const enrollInCourse = async (studentId, courseId, headers) => {
  try {
    const response = await api.post(`/api/courses/${courseId}/enroll`, { studentId, courseId },  headers );
    return response.data;
  } catch (error) {
    console.error(`Error enrolling student with ID ${studentId} in course with ID ${courseId}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Assign a teacher to a course
export const teachCourse = async (teacherId, courseId, headers) => {
  try {
    const response = await api.post(`/api/courses/${courseId}/teach`, { teacherId, courseId },  headers );
    return response.data;
  } catch (error) {
    console.error(`Error assigning teacher with ID ${teacherId} to course with ID ${courseId}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};